import React from 'react';
import DAOProposalRealDataTable from '@/components/tables/DAOProposalRealDataTable';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { UserRole } from '@/types';
import { useAuth } from '@/contexts/AuthContext';

interface DAOProposalPageProps {
  onNavigate: (view: string) => void;
}

const DAOProposalPage: React.FC<DAOProposalPageProps> = ({ onNavigate }) => {
  const { currentUser } = useAuth();

  return (
    <div className="space-y-8 animate-in fade-in">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white mb-1">DAO Proposal Dashboard</h1>
        <button
          onClick={() => onNavigate('dashboard')}
          className="bg-kala-secondary hover:bg-cyan-400 text-kala-900 font-bold py-2 px-4 rounded"
        >
          Back to Dashboard
        </button>
      </div>
      <div id="dao-proposal-tables" className="grid grid-cols-1 gap-8 mt-8">
        <DAOProposalRealDataTable currentUserRole={currentUser.role} currentUserId={currentUser.id} />
      </div>
    </div>
  );
};

export default DAOProposalPage;
